/* eslint-disable no-console */
'use client';

type PerfEvent = {
  name: string;
  t: number;
  data?: Record<string, unknown>;
};

declare global {
  interface Window {
    __perfEnabled?: boolean;
    __perfInitialized?: boolean;
    __perfEvents?: PerfEvent[];
  }
}

export const isPerfLoggingEnabled = () => {
  if (typeof window === 'undefined') return false;
  const params = new URLSearchParams(window.location.search);
  return params.has('perf') || localStorage.getItem('perf_log') === '1';
};

export const initPerfLogging = () => {
  if (typeof window === 'undefined') return false;
  if (window.__perfInitialized) return !!window.__perfEnabled;
  window.__perfInitialized = true;
  window.__perfEnabled = isPerfLoggingEnabled();
  if (window.__perfEnabled) {
    window.__perfEvents = [];
  }
  return !!window.__perfEnabled;
};

export const logPerf = (name: string, data?: Record<string, unknown>) => {
  if (typeof window === 'undefined') return;
  if (!window.__perfEnabled) return;
  const t = performance.now();
  const event: PerfEvent = { name, t, data };
  window.__perfEvents?.push(event);
  if (data) {
    console.log(`[perf] ${name} +${t.toFixed(1)}ms`, data);
  } else {
    console.log(`[perf] ${name} +${t.toFixed(1)}ms`);
  }
};
